import React from 'react';
import {
  Create,
  TabbedForm,
  FormTab,
  TopToolbar,
  ListButton,
} from 'react-admin';

import { parse } from 'query-string';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ReferencesForm from './ReferenceForm';

const Actions = ({ person, legalPerson }) => (
  <TopToolbar>
    <ListButton
      to={
        person
          ? `/people/${person}/show/references`
          : `/legal-people/${legalPerson}/show/references`
      }
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const ReferenceCreate = (props) => {
  const { person: personString, 'legal-person': legalPersonString } = parse(
    props.location.search
  );
  const person = personString ? parseInt(personString, 10) : '';
  const legalPerson = legalPersonString ? parseInt(legalPersonString, 10) : '';

  return (
    <Create
      title=''
      {...props}
      actions={<Actions person={person} legalPerson={legalPerson} />}
    >
      <TabbedForm
        initialValues={{ person, legalPerson }}
        redirect={
          person
            ? `/people/${person}/show/references`
            : `/legal-people/${legalPerson}/show/references`
        }
        variant='outlined'
      >
        <FormTab label='Referencia'>
          <ReferencesForm />
        </FormTab>
      </TabbedForm>
    </Create>
  );
};

export default ReferenceCreate;
